module.exports = __webpack_public_path__ + "static/Peter _ Jessica Kettner-dc4773a46b60aabae9ba56148987d71a.png";